import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 22,
    marginTop: 12,
    alignSelf: "center",
    minHeight: 350,
    width: 350,
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  hr: {
    height: 2,
    marginTop: 25,
    backgroundColor: "#2C2C2E",
    opacity: 0.5,
  },
  btn: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginTop: 12,
    alignSelf: "center",
    color: "#fff",
  },

  containerRadioBtn: {
    display: "flex",
    flexDirection: "row",
  },

  contentItemList: {
    flexDirection: "row",
    justifyContent: "flex-start",
    marginTop: 25,
  },
  initials: {
    padding: 10,
    borderWidth: 3,
    borderColor: "#196059",
    textAlign: "center",
    textAlignVertical: "center",
    color: "#196059",
    borderRadius: 10,
  },
  infoUser: {
    paddingLeft: 15,
    marginTop: 3,
  },
  nameUser: {
    fontSize: 14,
    color: "rgba(44, 44, 46, 0.8)",
    fontWeight: "bold",
  },
  emailUser: {
    fontSize: 14,
    color: "rgba(44, 44, 46, 0.8)",
    fontWeight: "400",
  },
  contentBtn: {
    position: "relative",
    marginTop: 50,
    marginBottom: 50,
    paddingHorizontal: 25,
    width: "100%",
  },

  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },

  lblInput: {
    paddingTop: 10,
    fontWeight: "bold",
  },

  containerInput: {
    marginBottom: 15,
    paddingHorizontal: 15,
  },

  inputBuscaUser: {
    paddingHorizontal: 15,
    backgroundColor: "transparent",
    textAlign: "left",
    borderColor: "#999999",
    borderWidth: 0.5,
    borderRadius: 4,
    minHeight: 50,
    color: "black",
  },

  txtBuscaUser: {
    paddingTop: 15,
    paddingBottom: 15,
    fontWeight: "bold",
    textAlign: "center",
    fontSize: 16,
    color: "#077A97",
    textTransform: "uppercase",
  },
});

export default styles;
